/**
 * App Component
 *
 * Main application component that renders the TanStack Router provider
 * wrapped with TanStack Query for data fetching.
 * All routing is handled by the router - see src/routes/ for route definitions.
 */

import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "./router";
import { queryClient } from "./lib/queryClient";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
